export default "__VITE_ASSET__BKlTGhgF__"